import { Box, Container, Typography } from "@mui/material";
import Seo from "components/Seo";
import configuration from "configuration";
import { useTranslation } from "react-i18next";

function PrivacyPolicyPage() {
  const { t, i18n } = useTranslation('privacyPolicy');

  return (
    <Container sx={{ mt: 6 }}>
      <Seo title={t("meta.privacy.title")} description={t("meta.privacy.desc")} />
      <Box component='section' sx={{ py: 4 }} dangerouslySetInnerHTML={{ __html: t('text', { email: configuration.mail }) }}>
      </Box>

    </Container>
  );
}

export default PrivacyPolicyPage;
